export function localeContent(locales, locale) {
  if (!locales) return null;
  if (locales[locale]) return locales[locale];
  if (locale === "zh-Hant" && locales["zh-Hans"]) return locales["zh-Hans"];
  if (locales.en) return locales.en;
  if (locales["zh-Hans"]) return locales["zh-Hans"];
  const first = Object.values(locales)[0];
  return first || null;
}
